
import React, { useEffect, useState } from 'react';
import { useProfileData } from '../../NecttosComp/APICaller/queryHooks';

import { Body, Main, Header } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';
import VerificationStudent from './VerificationStudent';
import HandleProceed from './HandleProceed';
import HandleReject from './HandleReject';
import ApplicationOpen from './AdmissionDataEdit';
import CallCandidate from './Callcandidate';
import HandleGiveTime from './HandleGiveTime'
import Rewardback from './Rewardback'
import TimerFunction from './TimerFunction';
import notFoundProfile from '../../static/images/library/noPhotoAvailable.png'

function AdmissionVerificationProcess({ userId, isStudent, stateData, refectData, whoAdmin, previousKeyMap, setStateData, keyData, onClose }) {

	const { data: userDetail } = useProfileData(userId, !isStudent);
	const studentData = userDetail;
	const [values, setValues] = useState('');
	const [state, setState] = useState({});
	useEffect(() => {
		setState({ ...state, dateTimer: new Date() })
	}, [])

	const handleCall = () => {
		setState({ ...state, callCandidate: true });
	};

	const handleVerify = () => {
		setState({ ...state, verificationStudent: true });
	};

	const handleReject = () => {
		setState({ ...state, handleReject: true });
	};

	const handleEdit = () => {
		setState({ ...state, handleEdit: true });
	};

	const handleGiveTime = () => {
		setState({ ...state, handleGiveTime: true });
	};

	const rewardback = () => {
		setState({ ...state, rewardBack: true });
	}

	if (!userId) {
		return (
			<div>
				<div>Select A User First</div>
			</div>
		);
	}
	return (
		<Main width={'95%'} height={'90%'} title='Verification Window'>
			<Header>
				<div></div>
				<div className='flex justify-end'>
					<Button type='close' onClick={onClose}>
						close
					</Button>
				</div>
			</Header>


			<Body>
				<div className="flex w-full justify-center items-center">


					<div className="flex flex-col items-center w-full max-w-3xl p-8 rounded-3xl shadow-2xl backdrop-blur-xl bg-gradient-to-br from-white/30 to-slate-100/20 dark:from-slate-800/50 dark:to-slate-900/30 text-white">


						<div className="flex justify-center gap-4 mb-6">
							<button
								onClick={handleEdit}
								className="px-3 py-1.5 rounded-md bg-orange-500 text-white text-xs font-semibold shadow hover:scale-105 transition-transform flex items-center gap-1.5"
							>
								<svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 17h2m2-2l6 6M2 12l6-6 6 6" />
								</svg>
								Edit
							</button>

							<button
								onClick={handleGiveTime}
								className="px-3 py-1.5 rounded-md bg-purple-500 text-white text-xs font-semibold shadow hover:scale-105 transition-transform flex items-center gap-1.5"
							>
								<svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
								</svg>
								Give Time
							</button>
							<button
								onClick={rewardback}
								className="px-3 py-1.5 rounded-md bg-red-400 text-white text-xs font-semibold shadow hover:scale-105 transition-transform flex items-center gap-1.5"
							>
								<svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 19l-9-7 9-7v14zm10 0l-9-7 9-7v14z" />
								</svg>
								Revert Back
							</button>

						</div>
						<TimerFunction start={true} date={state?.dateTimer} />
						<div className="relative w-80 h-80 mb-6">
							<img
								src={studentData?.photoURL || notFoundProfile}
								alt={studentData?.name || 'Name'}
								className="w-full h-full object-cover rounded-2xl shadow-lg"
							/>
							<div className="absolute bottom-0 left-0 w-full bg-black/50 backdrop-blur-sm rounded-b-2xl p-2">
								<div className="flex items-center justify-between">
									<div className="text-left ml-2">
										<h2 className="text-xl font-bold text-white">{studentData?.name}</h2>
										<p className="text-sm text-white/80">{studentData?.shortName} - Batch: </p>
										<p className="text-sm text-white/80" >{studentData?.batchName}</p>
									</div>
									<button
										onClick={handleCall}
										className="flex items-center flex-col gap-1 px-3 py-3 rounded-xl bg-green-600 text-white text-xs font-semibold hover:scale-105 transition-transform"
									>
										<svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
											<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h1.586a1 1 0 01.707.293l2.828 2.828a1 1 0 01.293.707V9a1 1 0 01-.293.707L8.414 11H7v2h1.414l1.293 1.293A1 1 0 0110 15v1.586a1 1 0 01-.293.707l-2.828 2.828a1 1 0 01-.707.293H5a2 2 0 01-2-2V5z" />
										</svg>
										<div>call</div>
									</button>
								</div>
							</div>
						</div>



						<div className="flex justify-center gap-6 mt-4">
							<button
								onClick={handleReject}
								className="w-[200px] h-[50px] rounded-xl bg-gradient-to-r from-red-400 to-red-600 text-white font-semibold shadow-lg hover:scale-[1.02] transition-transform backdrop-blur-sm flex items-center justify-center gap-2"
							>
								<svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
								</svg>
								Reject
							</button>

							<button
								onClick={handleVerify}
								className="w-[200px] h-[50px] rounded-xl bg-gradient-to-r from-blue-400 to-blue-600 text-white font-semibold shadow-lg hover:scale-[1.02] transition-transform backdrop-blur-sm flex items-center justify-center gap-2"
							>
								<svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
								</svg>
								Verify
							</button>
						</div>

					</div>


				</div>
			</Body>


			{state?.rewardBack && (
				<Rewardback
					userId={userId}
					isStudent={true}
					keyData={keyData}
					startDateTimer={state.dateTimer}
					TimerFunction={TimerFunction}
					state={values}
					setState={setValues}
					keyDataBack={previousKeyMap[keyData]}
					parentOnClose={onClose}
					onClose={() => {
						setState({ ...state, rewardBack: false });
					}}
					refectData={refectData}
					whoAdmin={whoAdmin}
				/>

			)}


			{state?.handleEdit && (
				<ApplicationOpen
					userId={userId}
					isStudent={true}
					keyData={keyData}
					startDateTimer={state.dateTimer}
					TimerFunction={TimerFunction}
					state={values}
					setState={setValues}
					parentOnClose={onClose}
					onClose={() => {
						setState({ ...state, handleEdit: false });
					}}
					refectData={refectData}
					whoAdmin={whoAdmin}
				/>
			)}

			{state?.handleGiveTime && (
				<HandleGiveTime
					userId={userId}
					isStudent={true}
					keyData={keyData}
					startDateTimer={state.dateTimer}
					TimerFunction={TimerFunction}
					stateData={state}
					setStateData={setState}
					parentOnClose={onClose}
					onClose={() => {
						setState({ ...state, handleGiveTime: false });
					}}
					refectData={refectData}
					whoAdmin={whoAdmin}
				/>
			)}

			{state?.handleReject && (
				<HandleReject
					userId={userId}
					isStudent={true}
					keyData={keyData}
					startDateTimer={state.dateTimer}
					TimerFunction={TimerFunction}
					stateData={state}
					setStateData={setState}
					parentOnClose={onClose}
					onClose={() => {
						setState({ ...state, handleReject: false, verificationProcess: true });
					}}
					refectData={refectData}
					whoAdmin={whoAdmin}
				/>
			)}

			{state?.handleProceed && (
				<HandleProceed
					userId={userId}
					isStudent={true}
					keyData={keyData}
					startDateTimer={state.dateTimer}
					TimerFunction={TimerFunction}
					stateData={state}
					setStateData={setState}
					parentOnClose={onClose}
					onClose={() => {
						setState({ ...state, handleProceed: false });
					}}

				/>
			)}

			{state?.verificationStudent && (
				<VerificationStudent
					userId={userId}
					isStudent={true}
					keyData={keyData}
					startDateTimer={state.dateTimer}
					TimerFunction={TimerFunction}
					stateData={state}
					setStateData={setState}
					parentOnClose={onClose}
					onClose={() => {
						setState({ ...state, verificationStudent: false });
					}}

				/>
			)}
			{state?.callCandidate && (
				<CallCandidate
					userId={userId}
					isStudent={true}
					keyData={keyData}
					startDateTimer={state.dateTimer}
					TimerFunction={TimerFunction}
					stateData={state}
					setStateData={setState}
					parentOnClose={onClose}
					onClose={() => {
						setState({ ...state, callCandidate: false });
					}}
				/>
			)}
		</Main>
	);
}

export default AdmissionVerificationProcess;
